<template>
  <div class="company-info df fdc">
    
    <h2>Upgrade to <strong>Ultimate</strong></h2>
    <p class="plan-subheading">You have selected to change your plan from <strong>{{planName}}</strong> to <strong>Free</strong>. You will not be charged after this period. Are you sure you want to change your plan to <strong>Free</strong>?</p>
    
    <div class="pricing-plan df fdr jcsb">
        <span class="pricing-plan-left f2 df fdc aic jcsb plan-title">
          <p>Free</p>
          <button class="button button-1 button-black"
                  v-if="$store.getters.companyPlan == 'Free'">
            Current Plan
          </button>
        </span>
        <span class="pricing-plan-right df fdr f4 jcsb">
          <span class="df fdc f1 jcsb">
            <p class="f1">Users</p>
            <p class="f1 number-of-things">1</p>
          </span>
          <span class="df fdc f1 jcsb">
            <p class="f1">Projects</p>
            <p class="f1 number-of-things">1</p>
          </span>
          <span class="df fdc f1 jcsb">
            <p class="f1">
              Features
            </p>
            <p class="f1">
              <span class="feature">Edit company</span>
              <span class="feature">Edit task rates</span>
              <span class="feature">Edit resources</span>
            </p>
          </span>
        </span>
      </div>

    <div class="box df fdc">
      <div class="plan-row df fdr jcsb">
        <p>Plan</p>
        <p>Price</p>
      </div>
      <div class="plan-row df fdr jcsb">
        <p class="plan-title">Free Plan</p>
        <div class="df fdr">
          <div class="df fdc jcfe mrx">
            <p>Tax 15%</p>
          </div>
          <div class="df fdc jcsb prices">
            <p>
              $0.00
            </p>
            <p>
              $0.00
            </p>
          </div>
        </div>
      </div>
      <hr/>
      <div class="plan-row df fdr jcsb total-row">
        <p class="plan-title"></p>
        <div class="df fdr">
          <div class="df fdc jcfe mrx">
            <p>Total</p>
          </div>
          <div class="df fdc jcsb prices">
            <p>
              $0.00
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="form-row df fdr">
      <span class="input-wrapper df fdc">
        <button class="button-form button-form-active" v-on:click="changePlan()">{{this.$store.getters.upgradeOrDowngrade('free')}}</button>
      </span>
      <span class="input-wrapper df fdc">
        <button class="button-form button-form-active" v-on:click="goTo('/pricing')">Cancel</button>
      </span>
    </div>
    
    <!-- <div class="page1 profile f1 box">
      <div class="basic-profile">
        <div class="form-row df fdr">
          <span class="input-wrapper input-wrapper-inner df fdr">
            <span class="input-wrapper df fdc">
              <p>Payment Type</p>
              <input v-on:input="changesMade()" value="Credit Card" disabled size="10" class="input1" type="text">
            </span>
            <span class="input-wrapper df fdc">
              <p>&nbsp;</p>
            </span>
          </span>
          <span class="input-wrapper df fdc">
          </span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p>Name on Card</p>
            <input v-on:input="changesMade()" v-model="name" class="input1" type="text">
          </span>
          <span class="input-wrapper input-wrapper-inner df fdr">
          </span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p>Card Number</p>
            <input v-on:input="changesMade()" v-model="cardNumber" class="input1" type="text">
          </span>
          <span class="input-wrapper input-wrapper-inner df fdr">
            <span class="input-wrapper df fdc">
              <p>Expiry Date</p>
              <input v-on:input="changesMade()" placeholder="01/2023" v-model="expiry" size="10" class="input1" type="text">
            </span>
            <span class="input-wrapper df fdc">
              <p>CVC</p>
              <input v-on:input="changesMade()" placeholder="123" v-model="cvc" size="10" class="input1" type="text">
            </span>
          </span>
        </div>
        <h4 class="mt0">Billing</h4>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p>Address</p>
            <input v-on:input="changesMade()" v-model="address" class="input1" type="text">
          </span>
          <span class="input-wrapper df fdc">
            <p>City</p>
            <input v-on:input="changesMade()" v-model="city" class="input1" type="text">
          </span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p>Country</p>
            <input v-on:input="changesMade()" v-model="country" class="input1" type="text">
          </span>
          <span class="input-wrapper input-wrapper-inner df fdr">
            <span class="input-wrapper df fdc">
              <p>Province</p>
              <input v-on:input="changesMade()" placeholder="ON" v-model="province" size="10" class="input1" type="text">
            </span>
            <span class="input-wrapper df fdc">
              <p>Zip/Postal Code</p>
              <input v-on:input="changesMade()" placeholder="A1B 2C3" v-model="postalCode" size="10" class="input1" type="text">
            </span>
          </span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <button class="button-form button-form-active" v-on:click="changePlan()">Change Plan</button>
          </span>
          <span class="input-wrapper df fdc">
            <button class="button-form button-form-active" v-on:click="goTo('/pricing')">Cancel</button>
          </span>
        </div>
      </div>
    </div> -->

  </div>
</template>

<script>
import router from '../../router'
export default {
  name: 'CompanyChangePlan',
  data () {
    return {
      profileChangesMade: false,
      name: this.$store.getters.userData.nameBilling,
      cardNumber: '',
      expiry: '',
      cvc: '',
      address: this.$store.getters.userData.addressBilling,
      city: this.$store.getters.userData.cityBilling,
      country: this.$store.getters.userData.countryBilling,
      province: this.$store.getters.userData.provinceBilling,
      postalCode: this.$store.getters.userData.postalCodeBilling
    }
  },
  props: [],
  components: {

  },
  methods: {
    changesMade () {
      this.profileChangesMade = true
    },
    changePlan () {
      var data = {
        company: this.$store.getters.myCompany,
        billingID: this.$store.getters.billingID,
        // name: this.name,
        // cardNumber: this.cardNumber,
        // expiry: this.expiry,
        // cvc: this.cvc,
        // address: this.address,
        // city: this.city,
        // country: this.country,
        // province: this.province,
        // postalCode: this.postalCode,
        // email: this.$store.getters.userData.email,
        // description: 'Account for ' + this.name,
        plan: 'free'
      }
      this.$emit('changePlan', data)
    },
    goTo (path) {
      console.log('GOINT TO...', path)
      router.push(path)
    }
  },
  computed: {
    planName: function () {
      if ((this.$store.getters.companyPlan == 'plan_FFDHScuKtmrCco') || (this.$store.getters.companyPlan == 'plan_F3CRngXCavmnen')) {
        return "Ultimate Plan"
      }
    }
  },
  created () {
    console.log('** CompanyChangePlan Loaded **')
    // try getting current user
      // exists - populate, set currentUser, requests will go to /update...
      // doesn't exist - requests will go to /create...
  }
}
</script>

<style scoped lang="scss">
  
  h2 {
    color: black;
  }

  .company-info {
    padding: 40px;

    & > .box {
      padding: 40px;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .plan-subheading {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .wrapper {
    width: 100%;
  }
  .pricing-plan {
    min-height: 210px;
    margin-bottom: 50px;
  }
  .pricing-plan-left {
    background-color: #D9EDFF;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    padding: 40px 0;
  }
  .pricing-plan-right {
    background-color: white;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    & > span {
      padding: 40px;
      &:last-child {
        & > p {
          &:first-child {
            margin-bottom: 40px;
          }
        }
      }
    }
  }
  .feature {
    display: block;
    margin-bottom: 4px;
  }
  .number-of-things {
    color: #000000;
    font-size: 48px;
    line-height: 57px;
  }
  .plan-price {
    color: #000000;
    font-size: 48px;
    line-height: 57px;
    position: relative;
    text-align: center;
    margin-top: 10px;

    & > sup {
      position: absolute;
      top: 14px;
      text-transform: uppercase;
      color: #000000;
      font-size: 14px;
      line-height: 4px;
    }
  }
  .plan-heading {
    color: #000000;
    font-size: 24px;
    line-height: 43px;
    margin-bottom: 5px;
  }

  .plan-row {
    margin-bottom: 10px;

    &:first-of-type {
      font-weight: 600;
    }

    &:last-of-type {
      margin-top: 15px;
      margin-bottom: 0;
    }
  }
  .plan-title {
    color: #000000;
    font-size: 36px;
    line-height: 42px;
  }
  .mrx {
    margin-right: 25px;
  }
  .prices {
    text-align: right;
  }
  hr {
    height: 1px;
    width: 100%;
    border: 0;
    background-color: #ccc;
  }
  .total-row {
    font-weight: 600;
  }
  h4 {
  margin-top: 75px;

  & > first-child {
    margin-top: 0;
  }
}

.wrapper {
  width: 100%;
  min-height: unset;
}

.profile {
  padding: 50px;
}

.form-row {
  width: 100%;

  & > span {
  }
}

.input-wrapper {
  margin-bottom: 20px;
  margin-right: 40px;
  flex: 1;

  & > p {
    color: #000000;
    font-size: 14px;
    letter-spacing: 0.5px;
    line-height: 25px;
  }
}

.input-wrapper-inner {
  flex: 1px;
  width: 50%;

  & > span {
    margin-right: 0;

    &:first-child {
      margin-right: 30px;
    }
  }
}

.delete-account-text {
  color: #000000;
  font-size: 18px;
  letter-spacing: 0.64px;
  line-height: 25px;
  margin-bottom: 30px;
}

.profile-photo-inner {
  border-radius: 8px;
  background-color: white;
  padding: 50px;
  margin-right: 30px;
  box-shadow: 0 1px 4px 0 rgba(0,0,0,0.32);
}

.profile-photo-details {
  flex: 1;
  margin-left: 50px;
}

.photo-buttons {
  & > button {
    &:first-child {
      margin-right: 40px;
    }
  }
}
</style>
